import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Studio from "@/pages/Studio";
import SharedPreview from "@/pages/SharedPreview";

function App() {
  return (
    <div className="App dark min-h-screen bg-[#050505] text-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Studio />} />
          <Route path="/p/:shareId" element={<SharedPreview />} />
          <Route path="/:shareId" element={<SharedPreview />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
